<template>
  <b-container
    fluid
    class="signin-wrapper d-flex flex-column align-items-center"
  >
    <alerts-component />
    <b-row
      class="d-flex flex-column align-items-center"
      style="max-width:500px;"
    >
      <div class="logo">
        <img src="@/assets/BET_logo_symbol.png">
      </div>
      <b-card>
        <b-form
          v-if="viewState === 'signIn'"
          id="sign-in-form"
          @submit.stop.prevent="onSubmit"
        >
          <b-form-group
            id="input-group-1"
            label="Password"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="$v.form.password.$model"
              type="password"
              placeholder="Enter password"
              :state="validateState('password')"
              aria-describedby="input-1-live-feedback"
            />
            <b-form-invalid-feedback id="input-1-live-feedback">
              This is a required password field
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label="Confirm Password"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="$v.form.confirmPassword.$model"
              type="password"
              placeholder="Enter password"
              :state="validateState('confirmPassword')"
              aria-describedby="input-2-live-feedback"
            />
            <b-form-invalid-feedback id="input-2-live-feedback">
              Passwords must be identical.
            </b-form-invalid-feedback>
          </b-form-group>
          <div class="d-flex justify-content-end">
            <b-button
              type="submit"
              variant="primary"
            >
              Submit
            </b-button>
          </div>
        </b-form>
        <div
          v-if="failed"
          style="color: red;"
        >
          {{ errorMessage }}
        </div>
      </b-card>
    </b-row>
  </b-container>
</template>
<script>
  import { required, sameAs } from "vuelidate/lib/validators";
  import validateStateMixin from "../../mixins/validateStateMixin";
  import AlertsComponent from "../../components/AlertsComponent";

  export default {
    components : {AlertsComponent},
    mixins: [validateStateMixin],
    data() {
      return {
        form: {
          password: "",
          token: "",
          id: "", 
          confirmPassword: ""
        },
        failed: false,
        errorMessage: "",
        viewState: "signIn"
      };
    },
    created() {
      this.form.token = this.$route.query.token;
      this.form.id = this.$route.query.id;
    },
    validations: {
      form: {
        password: {
          required
        },
        confirmPassword:{
          required,
          sameAsPassword: sameAs('password')
        }
      }
    },
    methods: {
      async onSubmit(evt) {
        this.failed = false;
        evt.preventDefault();
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }
        try{
          let response = await this.$http.post('/authentication/confirm-email',this.form);
          this.successAlert('The password was successfully set. You can now log in.')
          this.$router.push({ name: "signin" });
        }catch(error){
          this.failed = true;
          if (error.response && error.response.status === 400) {
            for (let errorId in error.response.data.errors) {
              error.response.data.errors[errorId].forEach(error => {
                this.errorMessage = error;
              })
            }
          } else {
            this.errorMessage = 'Something went wrong'
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";
  @import "@/assets/variables.scss";

  .signin-wrapper {
    padding-top: 150px;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.03);

    @include media-breakpoint-only(xs) {
      padding-top: 0px;
      justify-content: center;
    }
  }

  .logo {
    margin-bottom: 25px;

    img {
      width: 100px;
    }
  }

  a {
    color: $dark-grey;

    &:hover {
      text-decoration: none;
    }
  }

</style>
